// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"subtitle_subtitle__TvABo"};